import moment from 'moment';
import React, { useEffect, useState } from 'react';
import CmsItemListSection from '../../shared/cmsPage/components/CmsItemListSection';
import CmsPage from '../../shared/cmsPage/components/CmsPage';
import adminApi from '../api/adminApi';
import useAdminActions from '../hooks/useAdminActions';
import _ from 'lodash';

const AdminListPage = () => {
  const [roles, setRoles] = useState({});
  const [roleOptions, setRolOptions] = useState([]);
  useEffect(() => {
    (async () => {
      const map = await adminApi.getRoles();
      setRoles(map);
      setRolOptions(
        _.sortBy(
          Object.values(map).map(({ id, label }) => ({ label, value: id })),
          'label'
        )
      );
    })();
  }, []);

  const { toolbarActions, itemActions, AdminModal } = useAdminActions(roles);
  const columns = [
    { initialSort: 'ASC', label: 'Email', sortable: true, valueField: 'user_email' },
    {
      label: 'Role',
      sortable: true,
      valueField: 'role',
      renderer: (item) => roles[item.role]?.label || item.role,
    },
    {
      label: 'Last Sign In',
      sortable: true,
      valueField: 'lastSignIn',
      renderer: (item) =>
        item.lastSignIn ? moment(item.lastSignIn).local().format(`MMMM DD, YYYY  -  hh:mm a`) : '',
    },
  ];

  return (
    <CmsPage title="Admins">
      <CmsItemListSection
        showTotal
        pageId="admins"
        typeName="Admins"
        toolbarActions={toolbarActions}
        itemActions={itemActions}
        columns={columns}
        itemApi={adminApi}
        searchPlaceholder="Search by Email"
        additionalSearchFields={[
          {
            key: 'roles',
            noSelectText: 'Show All',
            placeholder: 'Roles',
            multiple: true,
            type: 'select',
            options: roleOptions,
          },
          { key: 'lastSignInStart', placeholder: 'Last Sign In Start', type: 'date' },
          { key: 'lastSignInEnd', placeholder: 'Last Sign In End', type: 'date' },
        ]}
      />
      {AdminModal}
    </CmsPage>
  );
};

export default AdminListPage;
